export default __webpack_public_path__ + "static/media/flayer77.171917a8.jpg";